import script from "./FolderDynamicTopMatter.vue?vue&type=script&setup=true&lang=ts"
export * from "./FolderDynamicTopMatter.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__